<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div box">
      <div class="list-header-title-div">活动管理</div>
      <el-tabs v-model="info.activityStatus" @tab-click="handleTabClick">
        <el-tab-pane label="已发布" name="02"></el-tab-pane>
        <el-tab-pane label="未发布" name="01"></el-tab-pane>
        <el-tab-pane label="已下架" name="03"></el-tab-pane>
        <el-tab-pane label="草  稿" name="04"></el-tab-pane>
        <el-tab-pane label="回收站" name="05"></el-tab-pane>
      </el-tabs>
      <div class="content-box">
        <div class="page-action-btns">
          <div style="width:400px">
            <el-input
              v-model="form.search"
              suffix-icon="el-icon-search"
              placeholder="输入要搜索的内容"
              @change="searchInput"
              size="mini"
              clearable
            ></el-input>
          </div>

          <div class="btn">
            <el-button @click="handelAddUrl">
              URL 导入
            </el-button>
            <el-button type="primary" @click="handelAdd">
              新 建
            </el-button>
          </div>
        </div>

        <!-- 表格 -->
        <div class="list-table activity-table">
          <template>
            <el-table
              :data="tableData"
              @row-click="handelClickRow"
              style="width: 100%"
            >
              <el-table-column
                prop="activityCover"
                label=""
                width="230px"
                align="center"
              >
                <template slot-scope="scope">
                  <el-image
                    style="width: 223px; height: 137px;border-radius: 8px;"
                    :src="scope.row.activityCover"
                    @click.native.stop
                    :preview-src-list="[scope.row.activityCover]"
                  >
                    <!-- @click.stop="showImage(scope.row.icon)" -->
                  </el-image>
                </template>
              </el-table-column>
              <el-table-column
                prop="activityTitle"
                label=""
                min-width="150"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="urlText"
                label=""
                min-width="150"
                align="center"
              >
                <template slot-scope="scope">
                  <p
                    class="herfUrl"
                    v-html="scope.row.urlText"
                    @click.stop="openUrl(scope.row)"
                  ></p>
                </template>
              </el-table-column>
              <el-table-column
                prop="readCount"
                label=""
                min-width="110"
                align="center"
                v-if="info.activityStatus == '02'"
              >
                <template slot-scope="scope">
                  <p>
                    阅读数
                    <span style="margin:10px">{{ scope.row.readCount }}</span>
                  </p>
                </template>
              </el-table-column>
              <el-table-column
                prop="createdWhen"
                label=""
                min-width="160"
                align="center"
                v-if="info.activityStatus == '02'"
              >
                <template slot-scope="scope">
                  <p>
                    文章<span style="margin:10px">{{
                      scope.row.createdWhen
                    }}</span
                    >已发布
                  </p>
                </template>
              </el-table-column>
              <el-table-column
                prop="createdWhen"
                label=""
                min-width="160"
                align="center"
                v-if="
                  info.activityStatus == '01' || info.activityStatus == '04'
                "
              >
                <template slot-scope="scope">
                  <p>
                    文章<span style="margin:10px">{{
                      scope.row.createdWhen
                    }}</span
                    >创建
                  </p>
                </template>
              </el-table-column>
              <el-table-column
                prop="activityPublishTime"
                label=""
                min-width="160"
                align="center"
                v-if="info.activityStatus == '01'"
              >
                <template slot-scope="scope">
                  <p>{{ scope.row.activityPublishTime }} 定时发布</p>
                </template>
              </el-table-column>
              <el-table-column
                prop="lastModifiedWhen"
                label=""
                min-width="160"
                align="center"
                v-if="info.activityStatus == '03'"
              >
                <template slot-scope="scope">
                  <p>{{ scope.row.lastModifiedWhen }} 已下架</p>
                </template>
              </el-table-column>

              <el-table-column prop="" label="" min-width="110" align="center">
                <template slot-scope="scope">
                  <div class="flex-x" v-if="info.activityStatus == '02'">
                    <p @click.stop="handelRow(scope.row, '03')">
                      下架
                    </p>
                  </div>
                  <div class="flex-x" v-if="info.activityStatus == '05'">
                    <p class="oldDel">
                      文章<span style="margin:10px">{{
                        scope.row.lastModifiedWhen
                      }}</span
                      >已删除
                    </p>
                  </div>
                  <div class="flex-x" v-if="info.activityStatus == '01'">
                    <p @click.stop="handelRelease(scope.row.activityId, '02')">
                      立即发布
                    </p>
                    <p @click.stop="handelEdit(scope.row)">编辑</p>
                    <p style="color:red" @click.stop="handelDel(scope.row)">
                      删除
                    </p>
                  </div>
                  <div class="flex-x" v-if="info.activityStatus == '03'">
                    <p @click.stop="handelRelease(scope.row.activityId, '02')">
                      重新发布
                    </p>
                    <p @click.stop="handelEdit(scope.row)">编辑</p>
                    <p style="color:red" @click.stop="handelDel(scope.row)">
                      删除
                    </p>
                  </div>
                  <div class="flex-x" v-if="info.activityStatus == '04'">
                    <p @click.stop="handelRelease(scope.row.activityId, '02')">
                      发布
                    </p>
                    <p @click.stop="handelEdit(scope.row)">编辑</p>
                    <p style="color:red" @click.stop="handelDel(scope.row)">
                      删除
                    </p>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </div>
      </div>
      <div class="list-pagination">
        <ZD-pagination
          :pagination="pagination"
          v-on:pageUpdate="getListData"
        ></ZD-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from './page-config'
export default {
  name: 'activityManagement',
  components: {},
  props: {},
  data() {
    return {
      pageConfig: pageConfig,
      pagination: pageConfig.pagination,//页码
      form: {}, //搜索内容
      info: {
        activityStatus: '02', //初始化活动状态
      },
      tableData: [], //表格数据
    }
  },
  computed: {},
  watch: {},
  created() {
    if (this.$route.params.activityStatus) {
      this.info.activityStatus = this.$route.params.activityStatus
    }
    this.init()
  },
  mounted() {},
  methods: {
    //打开网址
    openUrl(val) {
      if (val.activitySourceUrl != '') {
        let lg = val.activitySourceUrl.indexOf('http')
        if (lg < 0) {
          return window.open('http://' + val.activitySourceUrl)
        }
        window.open(val.activitySourceUrl)
      }
    },
    // 导航栏切换
    handleTabClick() {
      this.pageConfig.pagination.current = 1
      this.pageConfig.pagination.total = 0
      this.pageConfig.pagination.topageSizetal = 10
      this.getListData(this.pageConfig.pagination)
    },
    // 点击单行内容
    handelClickRow(e) {
      let obj = {}
      obj.activityStatus = this.info.activityStatus
      this.$store.commit('setEditId', e.activityId)
      this.$router.push({
        path: '/activityPreview',
        query: obj,
      })
    },
    //搜索
    searchInput(e) {
      this.info.activityTitle = this.form.search
      this.getListData(this.pageConfig.pagination)
    },
    //新建
    handelAdd() {
      this.$store.commit('setEditId')
      this.$router.push({
        name: 'activityDetail',
      })
    },
    //导入数据
    handelAddUrl() {
      this.$store.commit('setEditId')
      let obj = {}
      obj.url = true
      this.$router.push({
        path: '/activityDetail',
        query: obj,
      })
    },
    //     下架
    handelRow(row, num) {
      let _ = this
      _.$U.confirmThree(
        _,
        '是否下架下述内容?',
        row.activityTitle,
        row.activitySource,
        '阅读数' + row.readCount,
        () => {
          _.$U.showLoading(_)
          _.$H
            .post(_, _.$A.serviece.change, {
              activityId: row.activityId,
              activityStatus: num,
              activityStatusName: '已下架',
            })
            .then((res) => {
              _.$U.confirmSure(_, '下架成功', () => {
                _.info.activityStatus = num
                _.getListData(_.pageConfig.pagination)
              })
            })
        }
      )
    },
    //编辑
    handelEdit(e) {
      this.$store.commit('setEditId', e.activityId)
      let obj = {}
      obj.id = e.activityId
      obj.activityStatus = this.info.activityStatus
      if (e.activitySourceUrl != '') {
        obj.url = true
      }
      this.$router.push({
        path: '/activityDetail',
        query: obj,
      })
    },
    //     删除
    handelDel(row) {
      let _ = this
      _.$U.confirmThree(
        _,
        '确认删除下述内容?',
        row.activityTitle,
        row.activitySource,
        '',
        () => {
          _.$U.showLoading(_)
          _.$H.del(_, _.$A.serviece.del + row.activityId).then((res) => {
            _.$U.showLoading(_)
            _.$U.confirmSure(_, '删除成功', () => {
              _.info.activityStatus = '05'
              _.getListData(_.pageConfig.pagination)
            })
          })
        }
      )
    },
    //     发布
    handelRelease(e, num) {
      let _ = this
      _.$U.confirmDel(_, '确认是否发布?', '取消', '确定', () => {
        _.$H
          .post(_, _.$A.serviece.change, {
            activityId: e,
            activityStatus: num,
            activityStatusName: '已发布',
          })
          .then((res) => {
            _.$U.showLoading(_)
            _.$U.confirmSure(_, '发布成功', () => {
              _.info.activityStatus = num
              _.getListData(_.pageConfig.pagination)
            })
          })
      })
    },
    // 获取表格内容
    init() {
      this.getListData(this.pageConfig.pagination)
    },
    //获取表格内容
    getListData(val) {
      this.info.pageNum = val.current - 1
      this.info.pageSize = val.pageSize
      this.info.isDel = 'N'
      this.info.sort = '-lastModifiedWhen'
      if (this.info.activityStatus == '05') {
        this.info.isDel = 'Y'
        delete this.info.activityStatus
      }
      if (
        this.info.activityStatus == '01' ||
        this.info.activityStatus == '02'
      ) {
        this.info.sort = '-activityPublishTime'
      }
      let _ = this
      _.$U.showLoading(_)
      _.$H.get(_, _.$A.serviece.list, _.info).then((res) => {
        if (_.info.isDel == 'Y') {
          _.info.activityStatus = '05'
        }
        _.$U.hideLoading(_)
        let obj = res.data.data.content
        obj.forEach((item) => {
          if (item.activitySourceUrl != '') {
            item.urlText =
              "<p class='urlText'>" +
              item.activitySourceUrl +
              '</p>' +
              '<p>' +
              item.activitySource +
              '</p>'
          } else {
            item.urlText = item.activitySource
          }
        })
        _.tableData = obj || []
        _.pageConfig.pagination.total = res.data.data.totalElements || 0
      })
    },
  },
}
</script>

<style scoped lang="less">
.list-container .list-content-div {
  .content-box {
    margin-top: 10px;
    width: 100%;
    border: 2px solid #eaeaea;
    border-radius: 10px;
  }
  .page-action-btns {
    width: 100%;
    padding: 0px 25px 0px 25px;
    height: 73px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fafafa;
    .el-button--default {
      width: 128px;
      height: 40px;
      border: 1px solid #bb87f3;
      border-radius: 5px;
      background-color: #fff;
      color: #bb87f3;
    }
    .el-button--primary {
      width: 128px;
      height: 40px;
    }
  }
  .list-header-title-div {
    .is-top {
      .el-tabs__item {
        color: #8f9bb3;
      }
    }
  }
  .flex-x {
    display: flex;
    flex-wrap: wrap;
    justify-items: center;
    align-content: space-between;
    p {
      color: #bb87f3;
      width: 100%;
      cursor: pointer;
    }
    .oldDel {
      color: #c6c6c6;
    }
  }
}
</style>
